















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ModuleLayout } from './components';
import { IModules, Modules } from './types';

@Component({
  components: {
    ModuleLayout,
  },
})
export default class ComponentsPartsCatalogCardComponentsTabsModules
  extends Vue
  implements IModules {
  // Props
  @Prop({ type: Array, default: () => [] })
  modules: Modules;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/modules/Modules.vue